/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaListDialogSearchCapture/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputIcon from 'DesignSystem/TysiaInput/TysiaInputIcon/index'
import Tysiav2Search from 'DesignSystem/Svgs/Tysiav2Search/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaListDialogSearchCapture({
  children,
  viewPath = "/DesignSystem/TysiaListDialog/TysiaListDialogSearchCapture",
  autoFocus,
  placeholder = "Search"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let listDialogSearchTermValueData = fromData.useDataValue({ viewPath,
context: 'list_dialog',
path: 'search_term',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  autoFocus,
  placeholder
  
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaListDialogSearchCapture.Horizontal"
  data-view-path={viewPath}
 style={{'--bbc-1-Zum3Kh': dtColorsNeutral200,'--btc-2-Zum3Kh': dtColorsNeutral200,'--g-3-Zum3Kh': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 marginBottom={0}
 autoFocus={autoFocus}
 data="list_dialog.search_term"
 value={listDialogSearchTermValueData}
 onChange={onChange}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
 borderWidth={0}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 paddingTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<TysiaInputIcon
{...childProps}
  viewPath={`${viewPath}/TysiaInputIcon`}
>
{childProps => (
<div
  data-testid="TysiaListDialogSearchCapture.Vertical"
  data-view-path={viewPath}
 style={{'--mr-4-Zum3Kh': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2Search
  viewPath={`${viewPath}/Tysiav2Search`}
 width={14}
 height={14}
 fill2={dtColorsNeutral400}
/>
</div>
)}
</TysiaInputIcon>
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 placeholder={placeholder}
/>
</React.Fragment>
)}
</TysiaInputContent>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}